import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "APP_ROOT/api";
import AccountSelectionModal from "MODULES/Admin/Integrations/AccountSelectionModal";

function LocationPanel({ location, locations }) {
  const [qbUrl, setQbUrl] = useState(null);

  useEffect(() => {
    api.integrations.quickbooks.oauth(location.id).then(resp => {
      setQbUrl(resp.data.redirect_uri);

      return function cleanup() {};
    });
  }, []);

  if (!qbUrl) return null;
  return (
    <div className="col-sm-2">
      <div className="panel panel-default">
        <div className="panel-body pointer">
          <h4>{location.name}</h4>
          <Link to={{ pathname: qbUrl }} target="_blank">
            <img
              src="https://info-trader-assets.s3.us-east-2.amazonaws.com/logos/quickbooks-logo.png"
              alt="Quickbooks"
            />
          </Link>
          <AccountSelectionModal location={location} locations={locations} />
        </div>
      </div>
    </div>
  );
}

export default LocationPanel;



// WEBPACK FOOTER //
// ./app/modules/Admin/Integrations/LocationPanel.jsx